import React, { useCallback, useEffect, useState } from "react";
import { useAppSelector } from "src/store/actions/action";
import { setSearchStartDate, setSearchEndDate } from "src/store/reducers/asReduce";
import styled from "styled-components";
import Chip from "../common/Chip";
import moment from "moment";
import DatePicker, { registerLocale } from "react-datepicker";
import ko from "date-fns/locale/ko";
registerLocale("ko", ko);
import "src/styles/react-datepicker.css";
import DatapickerInput from "../common/Datepicker";
import CalendarHeader from "../common/CalendarHeader";
import { UserVo } from "src/vo/userVo";
import { isEmpty, result } from "lodash";
import { shallowEqual, useDispatch } from "react-redux";

const initVo: UserVo = {};

interface dataProps {
  asType?: JSON | any;
  storeType?: JSON | any;
  brandType?: JSON | any;
  dateType?: JSON | any;
  asStateType?: JSON | any;
  selectedChips?: Array<JSON | any>;
  setInitFunc?: any;
  userBrand?: string;
}

const SearchFilterItemCommon = (props: dataProps) => {
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const dispath = useDispatch();

  const [init, setInit] = useState<any>({
    asType: props.asType,
    storeType: props.storeType,
    brandType: props.brandType,
    dateType: props.dateType,
    asStateType: props.asStateType,
    selectedChips: [],
  });

  const { asType, storeType, brandType, dateType, asStateType, selectedChips } = init;

  const [state, setState] = useState(true);

  const [isSelectDateCheck, setIsSelectDateCheck] = useState<boolean>();

  const [isDatePicker, setIsDatePicker] = useState<boolean>(true);

  const [selectedLength, setSelectedLength] = useState<number>(0);

  const [brandCheck, setBrandCheck] = useState(true);

  // user 브랜드 체크에 따른 브랜드 필터 렌더링
  useEffect(() => {
    if (props.userBrand === "M" || props.userBrand === "I" || props.userBrand === "X" || props.userBrand === "A" || props.userBrand === "D") {
      setBrandCheck(false);
    }
  }, [props.userBrand]);

  // Datepicker
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const handleCalendarOpen = () => {
    document.addEventListener(
      "touchstart",
      (event: TouchEvent) => {
        event.stopPropagation();
      },
      true,
    );
  };

  useEffect(() => {
    setInit({
      ...init,
      asType: props.asType,
      storeType: props.storeType,
      brandType: props.brandType,
      dateType: props.dateType,
      asStateType: props.asStateType,
      selectedChips: props.selectedChips,
    });
    if (props.selectedChips) {
      if (props.setInitFunc) {
        if (props.selectedChips.length > 0) {
          props.setInitFunc(true);
        } else {
          props.setInitFunc(false);
        }
      }
    }
  }, [props]);

  useEffect(() => {
    if (isSelectDateCheck) {
      dispath(setSearchStartDate(moment(startDate).format("YYYY-MM-DD")));
      const result = new Date(endDate);
      result.setDate(result.getDate() + 1);
      dispath(setSearchEndDate(moment(result).format("YYYY-MM-DD")));
    }
  }, [isSelectDateCheck]);

  useEffect(() => {
    if (props.setInitFunc) {
      if (selectedLength > 0) {
        props.setInitFunc(true);
      } else {
        props.setInitFunc(false);
      }
    }
  }, [selectedLength]);

  useEffect(() => {
    if (isSelectDateCheck) {
      dispath(setSearchStartDate(moment(startDate).format("YYYY-MM-DD")));
      const result = new Date(endDate);
      result.setDate(result.getDate() + 1);
      dispath(setSearchEndDate(moment(result).format("YYYY-MM-DD")));
    }
  }, [startDate, endDate]);

  // 접수상태 클릭
  const asStateAddClick = (idx: number, e: React.MouseEvent, val: string) => {
    const newInit = { ...init };
    // 선택 조건 추가
    if (!selectedChips.includes(val)) {
      newInit.selectedChips.push(val);
    }

    setSelectedLength(selectedChips.length);

    const asStateArray = asStateType.check.map((v: any, i: number) => {
      if (idx === i) {
        if (!selectedChips.includes(val)) {
          selectedChips.push(val);
        }
        v = true;
      }
      return v;
    });
    asStateType.check = asStateArray;
    setState((state) => (state ? false : true));
  };

  // AS 유형 클릭
  const asAddClick = useCallback(
    (idx: number, e: React.MouseEvent, val: string) => {
      const newInit = { ...init };
      // 선택 조건 추가
      if (!selectedChips.includes(val)) {
        newInit.selectedChips.push(val);
      }
      setSelectedLength(selectedChips.length);

      const asArray = asType.check.map((v: any, i: number) => {
        if (idx === i) {
          if (!selectedChips.includes(val)) {
            selectedChips.push(val);
          }
          v = true;
        }
        return v;
      });
      asType.check = asArray;
      setState((state) => (state ? false : true));
    },
    [init],
  );

  // 매장 유형 클릭
  const storeAddClick = useCallback(
    (idx: number, e: React.MouseEvent, val: string) => {
      const newInit = { ...init };
      // 선택 조건 추가
      if (!selectedChips.includes(val)) {
        newInit.selectedChips.push(val);
      }
      setSelectedLength(selectedChips.length);
      const storeArray = storeType.check.map((v: any, i: number) => {
        if (idx === i) {
          if (!selectedChips.includes(val)) {
            selectedChips.push(val);
          }
          v = true;
        }
        return v;
      });

      storeType.check = storeArray;
      setState((state) => (state ? false : true));
    },
    [init],
  );

  // 브랜드 유형 클릭
  const brandAddClick = useCallback(
    (idx: number, e: React.MouseEvent, val: string) => {
      const newInit = { ...init };
      // 선택 조건 추가
      if (!selectedChips.includes(val)) {
        newInit.selectedChips.push(val);
      }
      setSelectedLength(selectedChips.length);
      const brandArray = brandType.check.map((v: any, i: number) => {
        if (idx === i) {
          if (!selectedChips.includes(val)) {
            selectedChips.push(val);
          }
          v = true;
        }
        return v;
      });

      brandType.check = brandArray;
      setState((state) => (state ? false : true));
    },
    [init],
  );

  const dateAddClick = (idx: number, e: React.MouseEvent, value: string) => {
    if (dateType.check.includes(true)) {
      return;
    }
    const dateArray = dateType.check.map((v: any, i: number) => {
      if (idx === i) {
        if (!selectedChips.includes(value)) {
          if (value === "기간선택") {
            setIsDatePicker(false);
            setIsSelectDateCheck(true);
          } else {
            setIsDatePicker(true);
            setIsSelectDateCheck(false);
          }
          selectedChips.push(value);
        }
        v = true;
      } else {
        v = false;
      }
      return v;
    });
    setSelectedLength(selectedChips.length);
    dateType.check = dateArray;
    setState((state) => (state ? false : true));
  };

  const deleteClick = (checkValue: string, idx: number) => {
    const newInit = { ...init };

    newInit.selectedChips.splice(idx, 1);

    setSelectedLength(selectedChips.length);
    // const newInit = { ...init }; 해당방식으로 해야 부모영역에서 props의 값을 인지한다!
    // 밑에 방식으로 하면 부모영역에서 props로 준 값의 변화를 인지를 못한다! 왜???

    if (!isEmpty(asType)) {
      asType.chip.map((value: any, selectIdx: number) => {
        if (value === checkValue) {
          asType.check[selectIdx] = false;
        }
        // return storeType.check[selectIdx];
      });
    }

    if (!isEmpty(storeType)) {
      storeType.chip.map((value: any, selectIdx: number) => {
        if (value === checkValue) {
          storeType.check[selectIdx] = false;
        }
        // return storeType.check[selectIdx];
      });
    }

    if (!isEmpty(brandType)) {
      brandType.chip.map((value: any, selectIdx: number) => {
        if (value === checkValue) {
          brandType.check[selectIdx] = false;
        }
        // return brandType.check[selectIdx];
      });
    }

    // storeType.check = deleteStore;
    if (!isEmpty(dateType)) {
      dateType.chip.map((value: any, selectIdx: number) => {
        if (value === checkValue) {
          if (value === "기간선택") {
            setIsDatePicker(true);
          }
          dateType.check[selectIdx] = false;
        }
      });
    }
    if (!isEmpty(asStateType)) {
      asStateType.chip.map((value: any, selectIdx: number) => {
        if (value === checkValue) {
          asStateType.check[selectIdx] = false;
        }
      });
    }

    setInit(newInit);
  };

  return (
    <>
      <FilterItemSet>
        <p className="title">선택한 조건</p>
        <div>
          {selectedChips?.map((v: any, i: any) => {
            return (
              <Chip variant="contained" key={i} deleted={true} onDelete={() => deleteClick(v, i)}>
                {v}
              </Chip>
            );
          })}
        </div>
      </FilterItemSet>
      {userInfo.user_type === "E" && brandCheck && brandType ? (
        <FilterItemSet>
          <p className="title">{brandType ? brandType.title : ""}</p>
          <div>
            {brandType.chip.map((val: any, idx: any) => {
              const check = brandType.check[idx];
              return (
                <Chip variant="outlined" selected={check} key={idx} onClick={(e) => brandAddClick(idx, e, val)}>
                  {val}
                </Chip>
              );
            })}
          </div>
        </FilterItemSet>
      ) : (
        ""
      )}
      {asStateType ? (
        <FilterItemSet>
          <p className="title">{asStateType ? asStateType.title : ""}</p>
          <div>
            {asStateType.chip.map((val: any, idx: any) => {
              const check = asStateType.check[idx];
              return (
                <Chip variant="outlined" selected={check} key={idx} onClick={(e) => asStateAddClick(idx, e, val)}>
                  {val}
                </Chip>
              );
            })}
          </div>
        </FilterItemSet>
      ) : (
        ""
      )}
      {asType ? (
        <FilterItemSet>
          <p className="title">{asType ? asType.title : ""}</p>
          <div>
            {asType.chip.map((val: any, idx: any) => {
              const check = asType.check[idx];
              return (
                <Chip variant="outlined" selected={check} key={idx} onClick={(e) => asAddClick(idx, e, val)}>
                  {val}
                </Chip>
              );
            })}
          </div>
        </FilterItemSet>
      ) : (
        ""
      )}

      {userInfo.user_type !== "S" && storeType ? (
        <FilterItemSet>
          <p className="title">{storeType ? storeType.title : ""}</p>
          <div>
            {storeType.chip.map((val: any, idx: any) => {
              const check = storeType.check[idx];
              return (
                <Chip variant="outlined" selected={check} key={idx} onClick={(e) => storeAddClick(idx, e, val)}>
                  {val}
                </Chip>
              );
            })}
          </div>
        </FilterItemSet>
      ) : (
        ""
      )}
      {dateType ? (
        <FilterItemSet>
          <p className="title">{dateType ? dateType.title : ""}</p>
          <div>
            {dateType
              ? dateType.chip.map((val: any, idx: any) => {
                  const check = dateType.check[idx];
                  return (
                    <Chip variant="outlined" selected={check} key={idx} onClick={(e) => dateAddClick(idx, e, val)}>
                      {val}
                    </Chip>
                  );
                })
              : ""}
            <DatePickerWrap style={{ background: isDatePicker ? "#f4f5f7" : "" }}>
              <DatePicker
                locale={ko}
                disabled={isDatePicker}
                selected={startDate}
                onChange={(date: any) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                maxDate={new Date()}
                withPortal
                onCalendarOpen={handleCalendarOpen}
                renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                  <CalendarHeader
                    data={{
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }}
                  />
                )}
                customInput={<DatapickerInput defaultValue={moment(startDate).format("YYYY.MM.DD")} />}
              />
              <span className="divide"></span>
              <DatePicker
                locale={ko}
                disabled={isDatePicker}
                selected={endDate}
                onChange={(date: any) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                // minDate={startDate}
                maxDate={new Date()}
                withPortal
                onCalendarOpen={handleCalendarOpen}
                renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                  <CalendarHeader
                    data={{
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }}
                  />
                )}
                customInput={<DatapickerInput defaultValue={moment(endDate).format("YYYY.MM.DD")} />}
              />
            </DatePickerWrap>
          </div>
        </FilterItemSet>
      ) : (
        ""
      )}
    </>
  );
};

const FilterItemSet = styled.li`
  .title {
    font-size: 16px;
    font-weight: 500;
  }
  > div {
    ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center", "wrap")}
    > div {
      margin: 15px 10px 0 0;
    }
  }
`;

const DatePickerWrap = styled.div`
  overflow: hidden;
  width: auto;
  max-width: 345px;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  border: 1px solid ${({ theme }) => theme.color.lineSecondary};
  border-radius: 14px;
  padding: 0 15px;
  > .react-datepicker-wrapper {
    width: 120px;
  }
  .divide {
    position: relative;
    display: block;
    height: 28px;
    width: 20px;
    padding: 0 10px;
    margin-right: 15px;
    flex: 1;
    &::before {
      position: absolute;
      left: 0;
      top: 50%;
      content: "";
      display: block;
      width: 20px;
      height: 1px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
  }
`;

export default SearchFilterItemCommon;
